import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { CurrencyBRLProxyPipe } from '../pipes/currency.pipe';

//import { CurrencyBRLProxyPipe } from './../pipes/currency.pipe';

@Injectable({
  providedIn: 'root',
})
export class FormValidationsService {
  constructor(
    private translateService: TranslateService,
    private currencyPipe: CurrencyBRLProxyPipe
  ) {}

  getErrorMsg(fieldName: string, validatorName: string, validatorValue?: any) {
    const config = {
      required: `${fieldName} é obrigatório.`,
      max: `Máximo permitido para ${fieldName} é ${validatorValue.max}.`,
      min: `Mínimo permitido para ${fieldName} é ${validatorValue.min}.`,
      minlength: `${fieldName} precisa ter no mínimo ${validatorValue.requiredLength} caracteres.`,
      maxlength: `${fieldName} precisa ter no máximo ${validatorValue.requiredLength} caracteres.`,
      cepInvalido: 'CEP inválido.',
      email: 'Email inválido.',
      emailInvalido: 'Email já cadastrado!',
      equalsTo: 'Campos não são iguais.',
      pattern: 'Campo inválido.',
      'Mask error': `${fieldName} é inválido.`,
      mask: `${fieldName} é inválido.`,
      lt: `${fieldName} deve ser menor que ${validatorValue.value}`,
      gt: `${fieldName} deve ser maior que ${validatorValue.value}`,
      gte: `${fieldName} deve ser maior ou igual que ${validatorValue.value}`,
      cgte: `${fieldName} deve ser maior ou igual a ${this.currencyPipe.transform(
        validatorValue.value
      )}`,
      clte: `${fieldName} deve ser menor ou igual a ${this.currencyPipe.transform(
        validatorValue.value
      )}`,
      clt: `${fieldName} deve ser menor que ${this.currencyPipe.transform(
        validatorValue.value
      )}`,
      number: 'Campo inválido.',
      date: 'Data inválida.',
      matDatepickerParse: 'Data inválida.',
      cnpjInvalid: 'Documento é inválido',
      cpfInvalid: 'Documento é inválido',
      passwordsNotSame: 'As senhas não são iguais',
      pixNotSame: 'As chaves pix não são iguais',
      balanceNotAvailable: 'Saldo não disponível',
      ccNumberInvalid: 'Número do cartão inválido',
      ccExpDateInvalid: 'Data de expiração inválida',
      ccSecurityCodeInvalid: 'Código de segurança inválido',
      bsDate: 'Data inválida',
    } as any;

    return config[validatorName];
  }
}
